// extracted by mini-css-extract-plugin
export default {"faqAnswerStyles":"FAQ_faqAnswerStyles__6alUn"};